
angular.module('theme.core.filters')

.filter('money', function($filter) {
	return function(amount, fractionsize) {
		if (!Intl || !Intl.NumberFormat) return amount;
		fractionsize = fractionsize || 2;
		var formatter = new Intl.NumberFormat('pl-PL', {
			style: 'decimal',
			minimumFractionDigits: fractionsize,
			maximumFractionDigits: fractionsize
		});
		str = formatter.format(amount);
		return str;
	}
});